import { useEffect, useRef, useState } from "react";
import AssetsDropdown from "./AssetsDropdown";
import { Plus } from "lucide-react";
import styles from "./NewAssets.module.scss";

export interface NewAssetProps {
  createNewVolume: () => void;
  createNewTemplate: () => void;
  createNewFolder: () => void;
}

const NewAsset = ({
  createNewVolume,
  createNewTemplate,
  createNewFolder,
}: NewAssetProps) => {
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const dropdownContainerRef = useRef<HTMLDivElement>(null);

  const toggelDropdown = () => {
    setDropdownOpen((prev) => !prev);
  };

  useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      if (
        dropdownContainerRef.current &&
        !dropdownContainerRef.current.contains(event.target as Node)
      ) {
        setDropdownOpen(false);
      }
    };

    if (isDropdownOpen) {
      document.addEventListener("mousedown", handleOutsideClick);
    } else {
      document.removeEventListener("mousedown", handleOutsideClick);
    }

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [isDropdownOpen]);

  return (
    <div className={styles.newAsset} ref={dropdownContainerRef}>
      <button className={styles.assetButton} onClick={toggelDropdown}>
        <Plus size={16} />
        New Asset
      </button>
      {isDropdownOpen && (
        <AssetsDropdown
          actions={{
            createNewVolume,
            createNewTemplate,
            createNewFolder,
          }}
          setIsOpen={setDropdownOpen}
        />
      )}
    </div>
  );
};

export default NewAsset;
